import { render, staticRenderFns } from "./EditOemCustomer.vue?vue&type=template&id=5d7d6bdc"
import script from "./EditOemCustomer.vue?vue&type=script&lang=js"
export * from "./EditOemCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports